'use client';

import { lazy, Suspense, type ComponentProps } from 'react';

import type CartPageClientType from '@eliadmin/core/src/components/cart/cart-page-client';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';

// The shared Core entry has no props; DLZ retains its server content and slots.
const CartPageClient = lazy(() => import('@eliadmin/core/src/components/cart/cart-page-client'));

export default function CartPageEntry(props: ComponentProps<typeof CartPageClientType>) {
  return (
    <Suspense fallback={<GenericLoader />}>
      <CartPageClient {...props} />
    </Suspense>
  );
}
